export const STATIC_PAGE_COPY_TH = {
  "/": {
    "title": "Heartopia.guide — แผนที่เกาะ สูตรอาหาร และตัวติดตามคอลเล็กชัน",
    "description":
      "คู่มือภาคสนาม Heartopia ที่ผู้เล่นสร้างขึ้น: แผนที่เกาะแบบโต้ตอบ ปลา แมลง นก พืชผล สูตรทำอาหาร NPC รหัสของขวัญ และตัวติดตามคอลเลกชันทั้งหมด",
  },
  "/map": {
    "title": "แผนที่เกาะ Heartopia แบบโต้ตอบ — สถานที่ทั้งหมด | Heartopia.guide",
    "description":
      "สำรวจแผนที่เกาะ Heartopia แบบเต็ม: ทุกสถานที่ พื้นที่ตกปลา NPC และร้านค้า พร้อมฟิลเตอร์สำหรับจุดตกปลา พื้นที่หาอาหาร และของสะสม",
  },
  "/tracker": {
    "title": "Heartopia Collection Tracker — ปลา แมลง นก และอื่นๆ | Heartopia.guide",
    "description":
      "ติดตามคอลเล็กชัน Heartopia: ทำเครื่องหมายปลา แมลง นก พืชผล ดอกไม้ ของเก็บได้ สูตรอาหาร และสัตว์ที่สะสมแล้ว ความคืบหน้าจะบันทึกไว้ในเบราว์เซอร์ของคุณ",
  },
  "/items": {
    "title": "ไอเทม Heartopia ทั้งหมด — แค็ตตาล็อกฉบับเต็ม | Heartopia.guide",
    "description":
      "ค้นหาแค็ตตาล็อกไอเทม Heartopia ทั้งปลา แมลง นก พืชผล ดอกไม้ อาหาร เครื่องมือ เฟอร์นิเจอร์ และอื่นๆ พร้อมราคาขายและแหล่งที่มา",
  },
  "/locations": {
    "title": "สถานที่ทั้งหมดใน Heartopia | Heartopia.guide",
    "description": "ทุกสถานที่ใน Heartopia: สิ่งที่คุณสามารถตกปลา จับ และหาอาหารได้ในแต่ละพื้นที่ รวมถึง NPC และร้านค้าที่คุณจะพบที่นั่น",
  },
  "/npcs": {
    "title": "NPC ใน Heartopia — บทบาท ร้านค้า และตารางเวลา | Heartopia.guide",
    "description": "พบกับ Heartopia NPC ทุกตัว: บทบาทของพวกเขาบนเกาะ ร้านค้าที่พวกเขาเปิด และสถานที่ที่จะพบพวกเขาในแต่ละวัน",
  },
  "/shops": {
    "title": "ร้านค้า Heartopia ทั้งหมดและสิ่งที่พวกเขาขาย | Heartopia.guide",
    "description": "ร้านค้าทุกร้านใน Heartopia ที่มีสต็อกเต็ม: ร้านค้าแต่ละร้านขายอะไร ราคา และร้านไหนที่ NPC ดำเนินการ",
  },
  "/wardrobe": {
    "title": "รวมเสื้อผ้าและเครื่องประดับทั้งหมดใน Heartopia | Heartopia.guide",
    "description":
      "เสื้อผ้าทั้ง 2,239 ชิ้นใน Heartopia — หมวก เสื้อ กางเกง รองเท้า กระเป๋า และทรงผม กรองตามประเภท คอลเลกชัน และสีได้ พร้อมราคาและทุกแบบ",
  },
  "/buildings": {
    "title": "รวมชิ้นส่วนสร้างบ้านทั้งหมดใน Heartopia — โหมดสร้าง | Heartopia.guide",
    "description":
      "ชิ้นส่วนโหมดสร้างทั้ง 452 ชิ้นใน Heartopia — ประตู หน้าต่าง หลังคา รั้ว ประติมากรรมผนัง และพื้นผิวผนังกับพื้น จัดกลุ่มตามสไตล์การสร้าง พร้อมราคา",
  },
  "/guides": {
    "title": "คู่มือ Heartopia — ตกปลา ทำอาหาร สัตว์เลี้ยง และเก็บเลเวล | Heartopia.guide",
    "description":
      "คู่มือ Heartopia ระดับเริ่มต้นและระดับสูง: การตกปลา การทำสวน การทำอาหาร การดูนก การจับแมลง การดูแลสัตว์เลี้ยง และกลยุทธ์การเก็บเลเวลอย่างรวดเร็ว",
  },
  "/achievements": {
    "title": "รายการความสำเร็จของ Heartopia | Heartopia.guide",
    "description": "รวมความสำเร็จทั้งหมดใน Heartopia พร้อมเงื่อนไข รางวัล และเคล็ดลับเพื่อเก็บบันทึกความสำเร็จให้ครบ",
  },
  "/weather": {
    "title": "คู่มือสภาพอากาศ Heartopia — สิ่งที่แต่ละสภาพอากาศปลดล็อค | Heartopia.guide",
    "description":
      "สภาพอากาศใน Heartopia ทำงานอย่างไร: ปลา แมลง และเหตุการณ์ใดบ้างที่ขึ้นอยู่กับฝน หิมะ และสภาวะอื่นๆ และวิธีการวางแผนการพยากรณ์",
  },
  "/events": {
    "title": "ปฏิทินอีเวนต์ Heartopia — อีเวนต์ปัจจุบันและที่ผ่านมา | Heartopia.guide",
    "description": "รวมอีเวนต์ Heartopia ทั้งอีเวนต์ตามฤดูกาลที่กำลังจัดและที่ผ่านมา ไอเทมพิเศษ และวิธีรับรางวัลก่อนอีเวนต์สิ้นสุด",
  },
  "/pets": {
    "title": "สัตว์เลี้ยงใน Heartopia — สุนัข แมว ลักษณะ และการดูแล | Heartopia.guide",
    "description":
      "ทุกอย่างเกี่ยวกับสัตว์เลี้ยง Heartopia: สุนัขและแมวทุกสายพันธุ์ ลักษณะสัตว์เลี้ยง และวิธีการรับเลี้ยง ให้อาหาร และดูแลเพื่อนของคุณ",
  },
  "/pets/dogs": {
    "title": "สุนัขทุกสายพันธุ์ใน Heartopia | Heartopia.guide",
    "description": "สุนัขทุกสายพันธุ์ที่คุณสามารถรับเลี้ยงได้ใน Heartopia โดยมีรูปลักษณ์ ลักษณะ และรายละเอียดการรับเลี้ยงสำหรับสุนัขแต่ละตัว",
  },
  "/pets/cats": {
    "title": "แมวทุกสายพันธุ์ใน Heartopia | Heartopia.guide",
    "description": "แมวทุกสายพันธุ์ที่คุณสามารถรับเลี้ยงได้ใน Heartopia โดยมีรูปลักษณ์ ลักษณะ และรายละเอียดการรับเลี้ยงสำหรับแมวแต่ละตัว",
  },
  "/pets/traits": {
    "title": "อธิบายลักษณะสัตว์เลี้ยง Heartopia | Heartopia.guide",
    "description":
      "ลักษณะบุคลิกภาพของสัตว์เลี้ยงทั้งหมดใน Heartopia และสิ่งที่พวกเขาทำ — ลักษณะดังกล่าวส่งผลต่อพฤติกรรมของสัตว์เลี้ยงของคุณอย่างไร และลักษณะใดที่ผสมผสานกันที่ควรมองหา",
  },
  "/pets/guide": {
    "title": "คู่มือดูแลสัตว์เลี้ยง Heartopia | Heartopia.guide",
    "description":
      "วิธีดูแลสัตว์เลี้ยงใน Heartopia: การรับเลี้ยง การให้อาหาร ความสุข การเดิน และทุกสิ่งทุกอย่างที่สุนัขหรือแมวของคุณต้องการในแต่ละวัน",
  },
  "/daily-checklist": {
    "title": "รายการตรวจสอบรายวัน Heartopia — ไม่พลาดงาน | Heartopia.guide",
    "description":
      "รายการตรวจสอบรายวันสำหรับ Heartopia: งานที่เกิดซ้ำ การรีเซ็ต และกิจวัตรเพื่อใช้ประโยชน์จากทุกวันในเกมให้เกิดประโยชน์สูงสุด",
  },
  "/codes": {
    "title": "โค้ดแลกรางวัล Heartopia — โค้ดที่ใช้ได้และของรางวัล | Heartopia.guide",
    "description": "รหัสของขวัญ Heartopia ที่ใช้งานอยู่ทั้งหมดและรางวัล รวมถึงวิธีแลก — มีการตรวจสอบและอัปเดตเป็นประจำ",
  },
  "/tracking-winter-season": {
    "title": "ตัวติดตามฤดูหนาว Heartopia | Heartopia.guide",
    "description":
      "ติดตามฤดูหนาวของ Heartopia: ปลาตามฤดูกาล แมลง ไอเทมกิจกรรม และทุกสิ่งที่คุณสามารถรวบรวมได้เฉพาะในช่วงฤดูหนาวเท่านั้น",
  },
  "/support": {
    "title": "สนับสนุน Heartopia.guide | Heartopia.guide",
    "description": "วิธีต่างๆ ในการสนับสนุน Heartopia.guide — คู่มือภาคสนามที่จัดทำโดยผู้เล่นฟรี — และช่วยอัปเดตอยู่เสมอสำหรับทุกคน",
  },
  "/news": {
    "title": "ข่าว Heartopia — อัปเดต อีเวนต์ และแพตช์ | Heartopia.guide",
    "description": "ข่าว Heartopia ล่าสุด: อัปเดตเกม อีเวนต์ตามฤดูกาล เนื้อหาใหม่ และสรุปแพตช์ในที่เดียว",
  },
  "/sitemap": {
    "title": "แผนผังเว็บไซต์ — ทุกหน้าใน Heartopia.guide | Heartopia.guide",
    "description": "เรียกดูทุกส่วนของ Heartopia.guide ในที่เดียว: ปลา แมลง นก ดอกไม้ สูตรอาหาร NPC สถานที่ คู่มือ และข่าวสาร",
  },
} as const;
